/* eslint-disable */
import r1 from './r1.js'
import runl from './runl.js'

var sss = function () {
  function i(e, t) {
    var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {
      ratio: 0
    };
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, i),
      e && "" !== e && t && (this.id = e,
        this.view = t,
        this.options = n,
        this.options.ratio && "number" == typeof this.options.ratio || (this.options.ratio = 0),
        this.visibility = !1,
        this.visible = !1,
        this.view.dataset.intersectionId = e,
        runl.default.bind(e, this))
  }
  return r1(i, [{
    key: "update",
    value: function (e) {
      this.visibility ? this.visibility = e.isIntersecting && Math.floor(e.intersectionRatio) > this.options.ratio : this.visibility = e.isIntersecting && Math.ceil(e.intersectionRatio) >= this.options.ratio
    }
  }, {
    key: "locate",
    value: function () {
      this.offsetTop = window.currentScrollTop + this.view.getBoundingClientRect().top,
        this.offsetBottom = this.offsetTop + this.view.offsetHeight
    }
  }, {
    key: "dispose",
    value: function () {
      runl.default.unbind(this.id, this),
        this.view = null,
        this.options = null,
        this.visibility = !1
    }
  }]),
    i
}();

var a = { default: sss }

export default a
